export default __webpack_public_path__ + "static/media/27-cn.1061f2ab.webp";